import { Modal } from "bootstrap";
import {
    forwardRef,
    useEffect,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import { toast } from "react-toastify";
// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";


const B2BActivityContactModal = forwardRef(
    (props, ref) => {

        const {
            leadDetails,
            getLeadData,
            getLeadFollowup,
        } = props;

        const modalRef = useRef(null);
        const modalInstanceRef = useRef(null);

        const [loading, setLoading] = useState(false);

        const [formData, setFormData] = useState({
            contactType: "",
            callBackDate: "",
            callBackTime: "",
            lastCallSummary: "",
            occuranceType: "",
        });

        const handleClose = () => {

            setFormData({
                contactType: "",
                callBackDate: "",
                callBackTime: "",
                lastCallSummary: "",
                occuranceType: "",
            });

            modalInstanceRef.current?.hide();
        };


        useEffect(() => {
            if (modalRef.current) {
                modalInstanceRef.current = new Modal(
                    modalRef.current
                );
            }
        }, []);

        useImperativeHandle(ref, () => ({
            toggle() {
                const el = modalRef.current;
                const modal = modalInstanceRef.current;

                if (!el || !modal) return;

                if (el.classList.contains("show")) {
                    modal.hide();
                } else {
                    modal.show();
                }
            },
        }));

        const handleChange = (e) => {
            const { name, value } = e.target;

            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        };

        
        const handleSubmit = async () => {
            try {
                setLoading(true);

                const res =
                    await b2bleadService.contactActivityUpdate(
                        leadDetails?.id,
                        formData
                    );

                if (res?.data?.status === "success") {

                    toast.success(res?.data?.message);

                    modalInstanceRef.current?.hide();

                    setFormData({
                        contactType: "",
                        callBackDate: "",
                        callBackTime: "",
                        lastCallSummary: "",
                        occuranceType: "",
                    });

                    getLeadData?.();
                    getLeadFollowup?.();
                }

            } catch (err) {
                toast.error(
                    err?.response?.data?.message ||
                        err.message
                );
            } finally {
                setLoading(false);
            }
        };

        return (
            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background: "rgba(15,23,42,0.55)",
                    backdropFilter: "blur(5px)",
                }}
            >
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content border-0 rounded-4 overflow-hidden">

                     
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "rgb(94, 44, 158)",
                            }}
                        >
                            <div>
                                <p className="mb-0 small opacity-75">
                                    Contact Activity Update
                                </p>
                            </div>

                            {/* CLOSE BUTTON */}
                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={handleClose}
                            >
                                <i className="fa fa-times" />
                            </button>
                        </div>

                       
                        <div className="modal-body p-4">

                            {/* CONTACT TYPE */}
                            <label className="form-label fw-semibold mb-2">
                                Contact Type
                            </label>

                            <div className="d-flex flex-wrap gap-3 mb-4">

                                {[
                                    "New Call",
                                    "Follow Up Call",
                                    "Email",
                                    "SMS",
                                ].map((type) => (
                                    <div
                                        className="form-check"
                                        key={type}
                                    >
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="contactType"
                                            value={type}
                                            checked={
                                                formData.contactType === type
                                            }
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label">
                                            {type}
                                        </label>
                                    </div>
                                ))}
                            </div>

                            {/* DATE + TIME */}
                            <div className="row g-3">

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Date
                                    </label>

                                    <input
                                        type="date"
                                        className="form-control rounded-3"
                                        name="callBackDate"
                                        value={formData.callBackDate}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label">
                                        Time
                                    </label>

                                    <input
                                        type="time"
                                        className="form-control rounded-3"
                                        name="callBackTime"
                                        value={formData.callBackTime}
                                        onChange={handleChange}
                                    />
                                </div>

                                {/* SUMMARY */}
                                <div className="col-md-12">
                                    <label className="form-label">
                                        Summary
                                    </label>

                                    <textarea
                                        rows={3}
                                        className="form-control rounded-3"
                                        name="lastCallSummary"
                                        value={formData.lastCallSummary}
                                        onChange={handleChange}
                                        placeholder="Write call summary..."
                                    />
                                </div>

                                {/* OCCURANCE TYPE */}
                                <div className="col-md-12 mt-2">

                                    <label className="form-label fw-semibold">
                                        Activity Status
                                    </label>

                                    <div className="d-flex gap-4">

                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="occuranceType"
                                                value="scheduled"
                                                checked={
                                                    formData.occuranceType ===
                                                    "scheduled"
                                                }
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label">
                                                Schedule Activity
                                            </label>
                                        </div>

                                        <div className="form-check">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="occuranceType"
                                                value="done"
                                                checked={
                                                    formData.occuranceType ===
                                                    "done"
                                                }
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label">
                                                Mark as Done
                                            </label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                      
                        <div className="modal-footer border-0 px-4 pb-4">

                            <button
                                type="button"
                                className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                onClick={handleClose}
                            >
                                Close
                            </button>

                            <button
                                type="button"
                                className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading
                                    ? "Updating..."
                                    : "Update Activity"}
                            </button>

                        </div>

                    </div>
                </div>
            </div>
        );
    }
);

export default B2BActivityContactModal;